import { render, staticRenderFns } from "./profileEvents.vue?vue&type=template&id=9d8405f0&scoped=true&"
import script from "./profileEvents.vue?vue&type=script&lang=js&"
export * from "./profileEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8405f0",
  null
  
)

export default component.exports